import ProHeader from './ProHeader';
import ProFooter from './ProFooter';
export default {
  name: 'layout',
  components: {
    ProHeader: ProHeader,
    ProFooter: ProFooter
  },
  setup: function setup() {}
};